// Импортируем React и хук 'useState' для управления состоянием (например, открыто/закрыто мобильное меню)
import React, { useState } from 'react';

// Импортируем файл стилей как модуль. Это современный подход, который гарантирует,
// что стили из этого файла будут применяться только к этому компоненту и не "протекут" наружу.
// Мы обращаемся к стилям как к свойствам объекта 'styles'.
import styles from './Header.module.css';

// Импортируем логотип из папки с ассетами. Сборщик (Webpack) обработает это изображение.
// Таким образом, мы не беспокоимся о путях к файлам в финальной сборке.
import logo from '../../assets/images/logo.svg';

const Header = () => {
  // Создаем состояние 'isMenuOpen' для отслеживания состояния мобильного меню.
  // По умолчанию меню закрыто (false). 'setIsMenuOpen' - функция для изменения этого состояния.
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Функция для переключения состояния мобильного меню.
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Функция, которая закрывает меню при клике на ссылку (важно для мобильной версии)
  const closeMenu = () => {
    setIsMenuOpen(false);
  }

  return (
    // Используем семантический тег <header> для лучшего SEO и доступности.
    // Применяем класс 'header' из нашего модуля стилей.
    <header className={styles.header}>
      {/* 
        Вспомогательный класс 'container' центрирует и ограничивает контент по ширине.
        'headerContainer' добавляет flexbox-выравнивание для элементов внутри шапки.
      */}
      <div className={`${styles.headerContainer} container`}>
        {/* Логотип сайта. Ссылка ведет на верх страницы. */}
        <a href="#home" className={styles.logo}>
          <img src={logo} alt="Логотип BRU.kz" />
          <span>BRU.kz</span>
        </a>

        {/* 
          Навигационное меню. Используем тег <nav> для семантики.
          Условный класс: если 'isMenuOpen' равно true, добавляется класс 'active',
          который сделает меню видимым на мобильных устройствах.
        */}
        <nav className={`${styles.nav} ${isMenuOpen ? styles.active : ''}`}>
          <ul className={styles.navList}>
            <li className={styles.navItem}>
              <a href="#benefits" className={styles.navLink} onClick={closeMenu}>Преимущества</a>
            </li>
            <li className={styles.navItem}>
              <a href="#catalog" className={styles.navLink} onClick={closeMenu}>Каталог</a>
            </li>
            <li className={styles.navItem}>
              <a href="#contact" className={styles.navLink} onClick={closeMenu}>Контакты</a>
            </li>
          </ul>
        </nav>

        {/* Блок с контактами и кнопкой, который виден на десктопах */}
        <div className={styles.contactBlock}>
          <a href="tel:+77771234567" className={styles.phoneLink}>+7 (777) 123-45-67</a>
          <a href="#contact" className={styles.ctaButton}>Заказать звонок</a>
        </div>

        {/* 
          Кнопка "Бургер-меню" для мобильных устройств.
          Она видна только на небольших экранах.
          При клике на нее вызывается функция 'toggleMenu'.
          Класс 'active' добавляется для анимации иконки в крестик.
        */}
        <button 
          className={`${styles.burgerMenu} ${isMenuOpen ? styles.active : ''}`} 
          onClick={toggleMenu}
          aria-label="Открыть меню"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </header>
  );
};

export default Header;